<template>
	<div class="centerx" style="min-width: 800px;" ref="popupContainer">
		<vs-popup :title="'Contrat N°' + selectedContract + ' ' + societyName"  :active.sync="isPopupActive">
			<div class="w-full" style="padding: 20px 20px 20px 48px !important;">
				<div class="vx-row w-full" style="background-color: rgba(var(--vs-primary),1); color: white; border-radius: 10px; padding: 15px; margin-bottom: 20px;">
					<div class="vx-row w-full flex" style="justify-content: center;">{{historicalProviders.length > 0 ? "Prestataire(s) historique(s)" : "Aucun prestataire historique"}}</div>
					<div class="vx-row w-full flex" style="justify-content: center;">
						<div v-if="historicalProviders.length > 0" class="vx-row center-content" style="margin: 0;">
							<div class="flex center" v-for="(account_manager_avatar, index) in historicalProviders" :key="index">
								<vx-tooltip
									:text="getProviderIdToName(account_manager_avatar.users_id)"
									position="top"
								>
									<vs-avatar
										style="border: 1px solid; border-color: white;"
										:text="getProviderIdToName(account_manager_avatar.users_id)"
										@click="autoselect(account_manager_avatar)"
									/>
								</vx-tooltip>
							</div>
						</div>
					</div>
				</div>
				<div class="vx-row w-full" style="justify-content: space-between;">
					<h3>Ajouter un netlink</h3>
					
					<vs-button
						icon-pack="feather" icon="icon-upload-cloud"
						color="dark"
						@click="displayImportPopup()"
					>Importer des netlinks
					</vs-button>

				</div>
				<div class="vx-row mb-2 w-full" style="margin-top: 20px; white-space: nowrap;">
					<div class="vx-row w-full">
						<div class="vx-col mb-2">
							<!-- PRESTATION -->
							<label for="" class="vs-select--label">Prestation</label>
							<div class="flex">
								<vs-select
									v-model="selectedProduct"
									class="w-full select-medium mr-2"
									:disabled="isLockNetlinkSelection"
									no-data="Aucune prestation"
									autocomplete
									:style="styleValidator('selectedProduct')"
									@change="validateOne(selectedProduct, 'selectedProduct')"
									id="product_options"
								>
									<vs-select-item
										:key="index"
										:value="item[0]"
										:text="item[1]"
										v-for="(item, index) in productOptions"
										class="w-full"
									/>
								</vs-select>
								<vx-tooltip v-if="validators['selectedProduct'] && validators['selectedProduct'].errText !== ''" :text="errText('selectedProduct')" class="ml-3">
									<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
								</vx-tooltip>
							</div>
						</div>
						<div v-if="!dns_id" class="vx-col mb-2">
							<label for="" class="vs-select--label">Netlink acheté ou Netlink NDD ?</label>
							<div class="flex">
								<vs-select
									:disabled="isLockNetlinkSelection"
									autocomplete
									v-model="newLinkTypeCategory"
									class="w-full select-medium mr-2"
									:style="styleValidator('newLinkTypeCategory')"
									@change="validateOne(newLinkTypeCategory, 'newLinkTypeCategory')"
								>
									<vs-select-item
										:key="index"
										:value="item.value"
										:text="item.text"
										v-for="(item, index) in linkTypesCategories"
										class="w-full"
									/>
								</vs-select>
							</div>
						</div>
						<vx-tooltip v-if="validators['newLinkTypeCategory'] && validators['newLinkTypeCategory'].errText !== ''" :text="errText('newLinkTypeCategory')" class="ml-3" style="align-self: self-end; margin-right: 20px;">
							<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
						</vx-tooltip>
						<div class="vx-col" v-if="!dns_id && newLinkTypeCategory == 0" style="white-space: nowrap;">
							<label for="" class="vs-select--label">Prestataire</label>
							<div class="flex">
								<vs-select
									:disabled="isLockNetlinkSelection"
									v-model="selectedProvider"
									class="w-full select-medium mr-2"
									autocomplete
									:style="styleValidator('selectedProvider')"
									@change="validateOne(selectedProvider, 'selectedProvider')"
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.society"
										v-for="(item, index) in netlinkProviders"
										class="w-full"
									/>
								</vs-select>
							</div>
						</div>
						<vx-tooltip v-if="!dns_id && newLinkTypeCategory == 0 && validators['selectedProvider'] && validators['selectedProvider'].errText !== ''" :text="errText('selectedProvider')" class="ml-3" style="align-self: self-end; margin-right: 20px;">
							<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
						</vx-tooltip>
						<div class="vx-col mb-2">
							<vx-input-group
								class="bottom"
							>	
								<label for="flatpickr" style="font-size: 10px; margin-left: 5px; color: grey;">Période</label>
								<br />
								<flat-pickr
									:disabled="isLockNetlinkSelection"
									id="flatpickr"
									v-model="period"
									:config="configDatePicker"
									style="width: 100px; text-align: center;"
									@keydown.native.delete.capture.stop.prevent
								/>
							</vx-input-group>
						</div>
						<div style="align-self: center; margin-top: -3px; margin-left: 10px;">
							<div class="vx-col pt-5">
								<vs-button v-if="isLockNetlinkSelection == false" @click="lockNetlinkSelection" style="height: 32px;">Valider</vs-button>
								<vs-button v-if="isLockNetlinkSelection == true" @click="unlockNetlinkSelection" style="height: 32px;">Déselectionner</vs-button>
							</div>
						</div>
					</div>
					<div class="vx-row mt-2 w-full" v-if="isLockNetlinkSelection" style="padding-left: 13px;">
						<vx-card>
							<NewNetlinkPopupTable ref="netlinkPopup" :linkTypeList="netlink_types" :societyId="society_id" :showNetlinkBuyer="true" :isFromNDD="newLinkTypeCategory" :linkType="newLinkType" @update-total-price="updateTotalPrice($event)" />
						</vx-card>
					</div>
					<div class="vx-row w-full" style="justify-content: right; margin-top: 30px;">
						<vs-button @click="submitForm">Enregistrer</vs-button>
					</div>
				</div>
			</div>
    	</vs-popup>
	</div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import Contract from "@/entities/Contract";
import Netlink from "@/entities/Netlink";
import Purchase from "@/entities/Purchase";
import Dns from "@/entities/Dns";
import Validator from "@/entities/Validator";
import Mission from "@/entities/Mission";

import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";

import NewNetlinkPopupTable from "@/components/tables/NewNetlinkPopupTable";
import VxTooltip from "../../components/widgets/vx-tooltip/VxTooltip.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";

import store from "@/store/store";
import ImportNetlinksPopup from '@/components/popups/ImportNetlinksPopup';

export default {
	name: "NewNetlinkForContractPopup",
	mixins: [dbFieldConvertor],
	components: {
		flatPickr,
		monthSelect,
		ImportNetlinksPopup,
		NewNetlinkPopupTable,
		VxTooltip
	},
	props: {
		apiUrl: String,
		popupActive: Boolean,
		dns_id: String,
		society_id: Number,
		selectedContract: Number,
		societyName: String,
		
		netlink_types: Array,
		products_categories: Array,
		providers: Array,
		services: Array,
		societies: Array,
		dns: Array
	},
	data() {
		return {
			// FORM SELECT OPTIONS
			productOptions: [],
			societyOptions: [],
			contractOptions: [],
			linkTypes: [],
			linkTypesCategories: [
				{text: "Netlink acheté", value: 0},
				{text: "Netlink NDD", value: 1},
			],

			// VARIABLES
			isLockNetlinkSelection: false,

			selectedDns: null,
			oneDns: Dns.getFormFields(),
			dnsProviders: [],

			netlink_list: [],
			netlinkService: null,
			newLinkTypeCategory: null,
			newLinkType: null,
			netlink: [],
			netlinkProviders: [],

			purchaseId: null,
			purchase: Purchase.getFormFields(),
			purchasePrice: 0,

			selectedProduct: null,
			selectedProvider: null,
			providerId: null,

			isDNSNetlink: null,
			showNewDNS: false,
			validators: {},
			check: true,
			isPopupActive: this.$props.popupActive,
			showImportNetlinkPopup: false,

			importNetlink: null,
			//period
			period: null,
			products: [],
			configDatePicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light"
					})
				],

			},

			historicalProviders: [],
		};
	},
	watch: {
		society_id: function(data){
			//console.log("selectedSociety watch");
			// this.purchase.contract_society_id = this.selectedSociety
			this.getAllContractsForSociety(data);
		},
		/*
		 * netlink_types: function(data){
		 *   this.linkTypes = data.filter(row => row.is_dns == 0)
		 * },
		 */
		newLinkType: function(data){
			this.isDNSNetlink = this.checkLinkTypeIsDNS(data);
		},
		dns_id: function(data){
			this.selectedDns = data;
		},
		providers: function() {
			this.createNetlinkProviderList();
			this.createDNSProviderList();
		},
		services: function() {
			this.createNetlinkProviderList();
			this.createDNSProviderList();
		}
	},
	created() {
		this.createDNSProviderList();
		this.createNetlinkProviderList();
		if(this.$props.dns_id){
			this.selectedDns = this.$props.dns_id;
		}
		let today = new Date(Date.now());
		this.period = `${today.getMonth() + 1}/${today.getFullYear()}`;
		this.getAllContractsForSociety(this.$props.society_id);
		this.getHistoricalPurchases();
	},
	computed: {

		activeUser: () => {
			return VueCookies.get("userInfo");
		},
	},
	methods: {
		autoselect(thisProvider){
			if(thisProvider.mission_id) this.selectedProduct = thisProvider.mission_id;
			this.period = thisProvider.period_date.substr(0, 7).split('-').reverse().join('/');
			this.newLinkTypeCategory = 0;
			this.selectedProvider = thisProvider.users_id;
		},
		displayImportPopup(){
		
			this.$http.get(this.apiUrl + "netlink/all").then(res => {
				this.netlink = res.data
			})

			//console.log("wtf",this.netlink)

			this.showImportNetlinkPopup = true;

			let ComponentClass = Vue.extend(ImportNetlinksPopup);
			let importPopup = new ComponentClass({
				propsData: {
					apiUrl: this.apiUrl,
					selectedContract: this.selectedContract,
					popupActive: this.showImportNetlinkPopup,
					netlink_types: this.netlink_types,
					services: this.services,
					providers: this.providers,
					netlink: this.netlink
				}
			});
			importPopup.$mount();
			importPopup.$on("refresh-data", () => {
				this.$emit("refresh-data");
			});

			this.$refs.popupContainer.appendChild(importPopup.$el);
		},

		async getHistoricalPurchases(){
			await this.$http.get(this.apiUrl + "account_manager_view/purchase/" + this.selectedContract)
				.then(res => {
					let list = []

					let purchasesNetlinking = res.data[0].filter(purchase => purchase.service_id == 10)
					
					for(let i = purchasesNetlinking.length - 1; i >= 0; i--){
						let check = true
						for(let item of list){
							if(item.users_id == purchasesNetlinking[i].users_id) check = false
						}
						if(check) list.push(purchasesNetlinking[i])
						if(list.length == 4) break
					}
					this.historicalProviders = list.reverse()
				})
				.catch(err => {
					//console.log(err);
				}
			);
		},

		getProviderIdToName(provider_id){
			// let provider_name = ""
			let provider = this.providers.find(provider => provider.id == provider_id);
			let provider_name = provider ? provider.society : "";
			return provider_name;
		},

		isRecurringLink(link_type){
			let foundIndex = this.netlink_types.findIndex(row => row.id == link_type);
			if(foundIndex >= 0){
				if(this.netlink_types[foundIndex].recurrency == 1) return true;
			}
			return false;
		},
		lockNetlinkSelection(){
			this.check = true;
			let fields = ["newLinkTypeCategory", "selectedProvider"];
			let fieldsVal = [this.newLinkTypeCategory, this.selectedProvider];
			for(let i = 0; i < fields.length; i++){
				let name = "isNumberConstraint";
				let value = fieldsVal[i];
				value === 0 ? value = "0" : "";
				value ? value = String(value) : "";
				value == null ? value = "" : "";
				this.validators[fields[i]] = new Validator({constraintName: name});
				this.validators[fields[i]].check(value);
				if(this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == ""){
					if(this.newLinkTypeCategory == 1 && fields[i] == "selectedProvider"){
						//
					}
					else{
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
						this.check = false;
					}
				}
				this.$forceUpdate();
			}
			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				// ADD Check parameters
				this.isLockNetlinkSelection = true;
				if(this.newLinkTypeCategory == 1){
					this.newLinkType = 3;
					this.selectedProvider = null;
				}
			}
		},
		unlockNetlinkSelection(){
			// ADD Check parameters
			this.isLockNetlinkSelection = false;
		},
		updateTotalPrice(price){
			// this.purchasePrice = price
		},

		validateOne(val, name){
			let value = val;
			value === 0 ? value = "0" : "";
			let constname = "";
			switch(name){
			case"selectedDns":
			case"selectedProvider":
			case"newLinkTypeCategory":
				value ? value = String(val) : "";
				value == null ? value = "" : "";
				constname = "isNumberConstraint";
				break;
			case"max_budget":
				constname = "priceConstraint";
				break;
			default:
				return "";
			}
			this.validators[name] = new Validator({constraintName: constname});
			this.validators[name].check(value);
			this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
			this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			this.$forceUpdate();
		},
		errText(name){
			if(this.validators[name] && this.validators[name].errText !== ""){
				return this.validators[name].errText;
			}
		},
		styleValidator(name){
			if(this.validators && this.validators[name] && this.validators[name].valid == false && this.validators[name].errText !== ""){
				return "border: 1px solid red !important; border-radius: 5px;";
			}
			else if(this.validators && this.validators[name] && this.validators[name].errText == ""){
				return "border: 1px solid green !important; border-radius: 5px;";
			}
			else{
				return "border: none !important; border-radius: none;";
			}
		},

		addPurchase(isDNS=false){
			return new Promise((resolve, reject) => {
				/*
				 * if(isDNS == false){
				 *   // this.purchase = this.$refs.dnsPurchasePopup.getPurchaseData()
				 * }else{
				 *   purchasePrice
				 *   this.purchase = this.$refs.netlinkPurchasePopup.getPurchaseData()
				 * }
				 */
				let today = new Date(Date.now());
				let formatedDate = this.purchase.boughtAt ? this.purchase.boughtAt.substring(0, 10) : today.toISOString().substring(0, 10);
				let period = `${this.period.split("/").reverse().join("-")}-01 02:00:00`

				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";
				
				this.$http.post(this.apiUrl + "purchase/add", {
					price: this.$refs.netlinkPopup.getPurchasePrice(),
					recurrence: this.purchase.recurrence,
					margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
					margin_rate: this.purchase.marginRate,
					is_billable: this.purchase.isBillable,
					commentary: this.purchase.commentary,
					bought_at: formatedDate,
					contract_id: this.selectedContract,
					contract_society_id: this.society_id,
					users_id: this.selectedProvider,
					service_id: this.netlinkService,
					is_delivered: 0,
					recurrence_active: this.purchase.recurrence,
					user_id: this.activeUser.id,
					period_date: period,
					mission_id: this.selectedProduct
				}).then(res => {
					// //console.log(res)
					this.purchaseId = res.data.insertId;
					this.$vs.notify({title: "Succès", text: "Achat ajouté avec succès."});
					resolve(res.data.insertId);
				}).catch(err => {
					//console.log(err);
					this.$vs.notify({title: "Echec", text: "L'achat n'a pas été ajouté."});
					reject(err);
				});
			});
		},

		addDNS(){ // CREATE DNS OBJECT
			return new Promise((resolve, reject) => {
				this.oneDns = this.$refs.dnsPurchasePopup.getDnsPopup();
				//console.log("this.purchaseId", this.purchaseId);
				if(this.purchaseId){
					//console.log(this.purchaseId);
					this.oneDns.purchase_id = this.purchaseId;
				}
				if(this.providerId){
					//console.log(this.providerId);
					this.oneDns.provider_id = this.providerId;
				}
				let formatedDate = this.oneDns.purchase_date.split("/").reverse().join("-");
				this.oneDns.purchase_date = formatedDate;
				this.oneDns.renew_date = formatedDate;
				let newDns = new Dns(this.oneDns);
				//console.log(newDns);
				newDns.create((err, res) => {
					if(err){
						//console.log(err);
						reject(err);
					}
					if(res) {
						//console.log(res);
						this.$store.dispatch("getAllDns");
						resolve(res.data.insertId);
					}
				});
			});
		},

		createNetlink(isDNS, netlink){
			return new Promise((resolve, reject) => {
				/*
				 * this.netlink =
				 * this.netlink.landingPage = this.netlink.landingPage;
				 * this.netlink.urlBought = this.netlink.urlBought;
				 */

				/*
				 * if(isDNS){
				 *   netlink.dns_id = this.selectedDns
				 * }
				 */

				if(this.purchaseId){
					//console.log(this.purchaseId);
					netlink.purchase_id = this.purchaseId;
				}
				//console.log("this.society_id", this.society_id);
				if(this.society_id){
					//console.log(this.society_id);
					netlink.society_id = this.society_id;
				}

				//console.log("this.selectedContract", this.selectedContract);
				if(this.selectedContract){
					//console.log(this.selectedContract);
					netlink.contract_id = this.selectedContract;
				}

				let newNetlink = new Netlink(netlink)

				newNetlink.create((err, res) => {
					if(err) //console.log(err);
					if(res) {
						//console.log(res.data.insertId);
						netlink.id = res.data.insertId;
						// this.netlink_list.push(newNetlink)
						resolve(res.data.insertId);
					}
				});
			});
		},

		addNetlink(isDNS=false){ // IMPLEMENT DNS LINKING
			return new Promise((resolve, reject) => {
				this.netlink_list = this.$refs.netlinkPopup.getNetlinkListData();
				let requests = [];
				for(let netlink of this.netlink_list){
					netlink.contract_id = this.selectedContract
					netlink.society_id = this.society_id
					requests.push(this.createNetlink(isDNS, netlink));
				}
				Promise.all(requests)
					.then(responses => {
						resolve(responses);
					});
			});
		},

		submitForm(){
			return new Promise((resolve, reject) => {
				if(this.$refs.netlinkPopup.netlink_list.length == 0){
					this.$vs.notify({
						title: "Echec",
						text: "Veuillez ajouter au moins un netlink."
					});
					return;
				}else{
					if(this.newLinkTypeCategory == 1){
						if(this.showNewDNS == true){
							// // Purchase DNS
							// this.addPurchase(true)
							// .then(result => {
							//   // Add DNS
							//   this.addDNS()
							//   .then(result2 => {
							//     this.selectedDns = result2
							//     // Add Netlink to DNS
							//     this.addNetlink(true)
							//     .then(result3 => {this.returnPrevRoute(); resolve(result3)})
							//     .catch(err3 => {//console.log(err3); reject(err3)})
							//   })
							//   .catch(err2 => {//console.log(err2); reject(err2)})
							// })
							// .catch(err => {//console.log(err); reject(err)})
						}
						else{
							// Add Netlink to DNS
							this.addNetlink(true)
								.then(result => {
									this.isPopupActive = false; 
									this.$emit("refresh-data");
									resolve(result);
								})
								.catch(err => {
									//console.log(err); reject(err);
								});
						}
						this.$emit("refresh-data");
					}
					else{
						// Purchase Netlink
						this.addPurchase()
							.then(result => {
								// Add Netlink
								this.addNetlink()
									.then(result2 => {
										this.isPopupActive = false; 
										this.$emit("refresh-data");
										resolve(result2);
									})
									.catch(err2 => {
										//console.log(err2); reject(err2);
									});
							})
							.catch(err => {
								//console.log(err); reject(err);
							});
					}
				}
			});
		},

		showDns(){
			this.showNewDNS = true;
		},
		closeDns(){
			this.showNewDNS = false;
		},
		checkLinkTypeIsDNS(linkTypeId){
			let foundLinkType = this.netlink_types.find(row => row.id == linkTypeId);
			if(foundLinkType){
				if(foundLinkType.is_dns == 1){
					return true;
				}
			}

			return false;
		},

		createDNSProviderList(){
			//Find DNS service id
			let dnsService = this.services.find(service => service.name == "NDD");
			//console.log("dnsService", this.services, dnsService);
			//Filter Providers on service id
			let dnsProviderList = [];
			if(dnsService){
				dnsProviderList = this.providers.filter(provider => provider.service_id_list ? provider.service_id_list.split(",").indexOf(dnsService.id.toString()) >= 0 : false);
			}
			this.dnsProviders = dnsProviderList;
		},

		createNetlinkProviderList(){
			//Find Netlink service id
			let netlinkService = this.services.find(service => service.name == "Netlinking");
			this.netlinkService = netlinkService.id;
			//console.log("netlinkService", this.services, netlinkService);
			//Filter Providers on service id
			let netlinkProviderList = [];
			if(netlinkService){
				netlinkProviderList = this.providers.filter(provider => provider.service_id_list ? provider.service_id_list.split(",").indexOf(netlinkService.id.toString()) >= 0 : false);
			}
			this.netlinkProviders = netlinkProviderList;
		},

		getAllContractsForSociety(societyId){
			Contract.getContractsforSociety(societyId, (err, res) => {
				if(err) //console.log(err);
				if(res) {
					this.contractOptions = res;
					//console.log("this.contractOptions.length", this.contractOptions.length);
					if(this.contractOptions.length > 0){
						this.selectedContract = this.contractOptions[0].id;
					}
					else{
						this.selectedContract = null;
					}
					Mission.getMissionsForContract(this.selectedContract, (error, result) => {
						if(error) //console.log(error);
						if(result) {
							this.$http.get(this.apiUrl + "product/all").then(results => {
								this.products = results.data;

								let missionList = []
								for(let mission of result){
									let item;

									if(mission.commentary){
										if(this.products.filter(product => product.id == mission.products_id && product.sub_category == 7).length > 0) item = `${this.products.filter(product => product.id == mission.products_id && product.sub_category == 7)[0].perform}: ${mission.commentary}`;
									}else{
										if(this.products.filter(product => product.id == mission.products_id && product.sub_category == 7).length > 0) item = this.products.filter(product => product.id == mission.products_id && product.sub_category == 7)[0].perform;
									}
									if(item) missionList.push([mission.id, item]);
								}
								this.productOptions = missionList;
								
								if(this.productOptions.length > 0) this.selectedProduct = this.productOptions[0][0];
								else this.selectedProduct = null;
							})
						}
					});
				}
			});
			//console.log("getAllContractsForSociety");
		},
	}
};
</script>

<style scoped>

.role_selector_container {
  justify-content: space-between;
  width: 40%;
}

.role_container {
  justify-content: center;
}

.space_div {
  margin: 5px;
}

.bottom {
  align-self: flex-end;
}

.right_element {
  justify-content: flex-end;
}
</style>

